(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9816],{

/***/ 8837:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5444);
/* harmony import */ var _constants_theme__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7579);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5893);




var devices = _constants_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.devices */ .r.devices,
    fontSizes = _constants_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.fontSizes */ .r.fontSizes,
    colors = _constants_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.colors */ .r.colors,
    spaces = _constants_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.spaces */ .r.spaces; // eslint-disable-next-line prettier/prettier, react/display-name

var StyledStep = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "Step__StyledStep",
  componentId: "sc-1bvcgel-0"
})(["display:inline-flex;flex-direction:column;align-items:center;padding:", "px ", "px;background:linear-gradient( 180deg,", " 0%,rgba(255,255,255,0) 100% );border-radius:30px;flex:none;order:0;align-self:stretch;flex-grow:1;width:100%;height:100%;@media ", "{padding-top:", "px;padding-bottom:", "px;padding-left:", "px;padding-right:", "px;}"], spaces.large7X - 2, spaces.large2X - 2, colors.blue[50], devices.tablet, spaces.large2X, spaces.large2X, spaces.large, spaces.large);
var StyledStepIconContainer = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "Step__StyledStepIconContainer",
  componentId: "sc-1bvcgel-1"
})(["margin-top:", "px;margin-bottom:", "px;margin-left:", "px;margin-right:", "px;svg{height:180px;width:180px;}img{min-height:180px;}@media ", "{margin-left:auto;margin-right:auto;}"], spaces.large2X - 2, spaces.large2X - 2, spaces.large10X, spaces.large10X, devices.tablet);
var StyledTop = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "Step__StyledTop",
  componentId: "sc-1bvcgel-2"
})(["font-family:'Aeonik';font-style:normal;font-weight:500;font-size:", "px;line-height:130%;text-align:center;color:", ";flex:none;order:0;align-self:stretch;flex-grow:0;"], fontSizes.regular, colors.blue[600]);
var StyledBottom = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "Step__StyledBottom",
  componentId: "sc-1bvcgel-3"
})(["flex-grow:1;.header{font-family:'Aeonik';font-style:normal;font-weight:500;font-size:", "px;line-height:150%;text-align:center;color:", ";flex:none;order:0;align-self:stretch;flex-grow:0;}.description{font-family:'Aeonik';font-style:normal;font-weight:400;font-size:", "px;line-height:150%;text-align:center;color:", ";flex:none;order:1;align-self:stretch;flex-grow:0;}"], fontSizes.large2X, colors.gray[800], fontSizes.large, colors.gray[700]);

var Step = function Step(_ref) {
  var imgSrc = _ref.imgSrc,
      top = _ref.top,
      bottom = _ref.bottom;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(StyledStep, {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledTop, {
      children: top
    }), imgSrc && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledStepIconContainer, {
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("picture", {
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("source", {
          srcSet: imgSrc,
          type: "image/png"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("img", {
          src: imgSrc,
          alt: "Banner image"
        })]
      })
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledBottom, {
      children: bottom
    })]
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (Step);

/***/ }),

/***/ 3779:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(5444);
/* harmony import */ var _constants_theme__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7579);
/* harmony import */ var _constants_icons__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(934);
/* harmony import */ var _components_atomic_PriceBanner__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1219);
/* harmony import */ var _components_atomic_Icon__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6668);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(5893);







var colors = _constants_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.colors */ .r.colors,
    devices = _constants_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.devices */ .r.devices,
    fontSizes = _constants_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.fontSizes */ .r.fontSizes,
    spaces = _constants_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.spaces */ .r.spaces;
var StyledPriceSection = styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "PriceSection__StyledPriceSection",
  componentId: "sc-zxr9wt-0"
})(["max-width:", "px;width:100%;margin-bottom:", "px;@media ", "{margin-left:0;margin-right:0;margin-bottom:", "px;}"], spaces.large24X * 10 + 80, spaces.large24X, devices.tablet, spaces.large9X);
var StyledPriceBannerBadgeTextContainer = styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "PriceSection__StyledPriceBannerBadgeTextContainer",
  componentId: "sc-zxr9wt-1"
})(["padding-top:", "px;padding-left:", "px;padding-right:", "px;font-family:'Aeonik';font-style:normal;font-weight:700;font-size:", "px;line-height:130%;color:", ";"], spaces.large, spaces.large9X, spaces.large9X, fontSizes.large12X + 2, colors.white);
var StyledPriceBannerBadgeSubtextContainer = styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "PriceSection__StyledPriceBannerBadgeSubtextContainer",
  componentId: "sc-zxr9wt-2"
})(["padding-top:", "px;padding-left:", "px;padding-right:", "px;padding-bottom:", "px;font-family:'Aeonik';font-style:normal;font-weight:500;font-size:", "px;line-height:150%;color:", ";text-align:center;"], spaces.small2X, spaces.large7X, spaces.large7X, spaces.large3X, fontSizes.large, colors.white);
var StyledPriceBannerTitleContainer = styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "PriceSection__StyledPriceBannerTitleContainer",
  componentId: "sc-zxr9wt-3"
})(["display:flex;flex-direction:column;align-items:flex-start;margin-bottom:", "px;font-family:'Aeonik';font-style:normal;font-weight:500;font-size:", "px;line-height:130%;color:", ";span{display:block;width:100%;}span:last-child{margin-top:", "px;font-size:", "px;line-height:150%;}@media ", "{margin-top:", "px;margin-bottom:", "px;text-align:center;font-size:", "px;}"], spaces.large6X, fontSizes.large11X, colors.white, spaces.smallX, fontSizes.regular, devices.tablet, spaces.regular, spaces.large2X, fontSizes.large2X);
var StyledPriceBannerBodyContainer = styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "PriceSection__StyledPriceBannerBodyContainer",
  componentId: "sc-zxr9wt-4"
})(["@media ", "{margin-bottom:", "px;}"], devices.tablet, spaces.smallX);
var StyledBullet = styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "PriceSection__StyledBullet",
  componentId: "sc-zxr9wt-5"
})(["display:flex;align-items:center;margin-bottom:", "px;&:last-child{margin-bottom:", "px;}"], spaces.small - 2, spaces.large2X);
var StyledBulletIconContainer = styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "PriceSection__StyledBulletIconContainer",
  componentId: "sc-zxr9wt-6"
})(["margin-right:", "px;"], spaces.small);
var StyledBulletText = styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "PriceSection__StyledBulletText",
  componentId: "sc-zxr9wt-7"
})(["flex-grow:1;font-family:'Aeonik';font-style:normal;font-size:", "px;font-weight:400;color:", ";@media ", "{font-size:", "px;}"], fontSizes.large, colors.white, devices.tablet, fontSizes.regular);
var StyledUnderBulletsText = styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "PriceSection__StyledUnderBulletsText",
  componentId: "sc-zxr9wt-8"
})(["margin-top:", "px;flex-grow:1;font-family:'Aeonik';font-style:normal;font-size:", "px;font-weight:300;color:", ";font-style:italic;@media ", "{margin-top:", "px;}"], spaces.large4X, fontSizes.regular, colors.white, devices.tablet, spaces.large2X);

var PriceSection = function PriceSection(_ref) {
  var title = _ref.title,
      subtitle = _ref.subtitle,
      price = _ref.price,
      priceText = _ref.priceText,
      bullets = _ref.bullets,
      underBulletsText = _ref.underBulletsText,
      buttons = _ref.buttons;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(StyledPriceSection, {
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(_components_atomic_PriceBanner__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
      notRoundedMobile: true,
      innerSpace: spaces.large9X,
      roundingRadius: 40,
      footer: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(StyledUnderBulletsText, {
        children: underBulletsText
      }),
      badgeRoundingRadius: 30,
      color: {
        gradient: {
          from: colors.blue[600],
          to: colors.blue[500]
        }
      },
      title: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)(StyledPriceBannerTitleContainer, {
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("span", {
          children: title
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("span", {
          children: subtitle
        })]
      }),
      badgeText: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(StyledPriceBannerBadgeTextContainer, {
        children: "$".concat((price === null || price === void 0 ? void 0 : price.toFixed(2)) || '0.00')
      }),
      badgeSubtext: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(StyledPriceBannerBadgeSubtextContainer, {
        children: priceText
      }),
      buttons: buttons,
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(StyledPriceBannerBodyContainer, {
        children: bullets === null || bullets === void 0 ? void 0 : bullets.map(function (bullet, idx) {
          return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)(StyledBullet, {
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(StyledBulletIconContainer, {
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(_components_atomic_Icon__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                alias: _constants_icons__WEBPACK_IMPORTED_MODULE_1__/* .ICONS_ALIASES.checkRounded */ .F.checkRounded,
                color: colors.white
              })
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(StyledBulletText, {
              children: bullet
            })]
          }, "bullet:".concat(idx));
        })
      })
    })
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (PriceSection);

/***/ }),

/***/ 5119:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _builds_innova_labs_developers_trademark_trademark_frontend_v2_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(6835);
/* harmony import */ var _constants_theme__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7579);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(5444);
/* harmony import */ var _components_atomic_Step__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8837);
/* harmony import */ var _components_atomic_Icon__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6668);
/* harmony import */ var _constants_icons__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(934);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(7294);
/* harmony import */ var swiper_react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(719);
/* harmony import */ var swiper_css__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(1082);
/* harmony import */ var swiper_css__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(swiper_css__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var swiper__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(1911);
/* harmony import */ var _hooks__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(5125);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(5893);













var colors = _constants_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.colors */ .r.colors,
    devices = _constants_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.devices */ .r.devices,
    fontSizes = _constants_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.fontSizes */ .r.fontSizes,
    spaces = _constants_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.spaces */ .r.spaces;
swiper__WEBPACK_IMPORTED_MODULE_7__/* ["default"].use */ .ZP.use([swiper__WEBPACK_IMPORTED_MODULE_7__/* .Navigation */ .W_]);
var StyledThreeStepSection = styled_components__WEBPACK_IMPORTED_MODULE_10__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "ThreeStepSection__StyledThreeStepSection",
  componentId: "sc-1yhv8uz-0"
})(["max-width:", "px;width:100%;margin-top:", "px;display:flex;flex-direction:column;justify-content:center;.headerSection{font-family:'Aeonik';font-style:normal;font-weight:500;font-size:", "px;line-height:130%;text-align:center;color:", ";flex:none;order:0;align-self:stretch;flex-grow:0;}.subHeaderSection{font-family:'Aeonik';font-style:normal;font-weight:400;font-size:", "px;line-height:150%;margin-top:", "px;text-align:center;color:", ";flex:none;order:0;align-self:stretch;flex-grow:0;}.columnDesktopContainer{display:flex;margin-top:", "px;justify-content:center;gap:13px;}.columnMobileContainer{display:none;}@media ", "{margin-top:", "px;margin-bottom:", "px;margin-left:0;margin-right:0;display:flex;flex-direction:column;justify-content:center;align-items:center;gap:0px;flex:none;order:1;flex-grow:0;.headerSection{padding:0px ", "px;font-size:", "px;line-height:150%;}.subHeaderSection{padding:0px ", "px;font-size:", "px;line-height:150%;margin-top:", "px;margin-bottom:", "px;}.columnDesktopContainer{display:none;}.columnMobileContainer{display:block;width:100%;padding-left:", "px;padding-right:", "px;}.swiper-slide{width:90%;}}"], spaces.large24X * 10 + 80, spaces.large24X, fontSizes.large11X, colors.gray[800], fontSizes.large, spaces.medium, colors.gray[700], spaces.large7X - 2, devices.tablet, spaces.large9X, spaces.large9X, spaces.regular, fontSizes.large2X, spaces.regular, fontSizes.regular, spaces.smallX, spaces.large2X, spaces.regular, spaces.regular);
var StyledStep = styled_components__WEBPACK_IMPORTED_MODULE_10__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "ThreeStepSection__StyledStep",
  componentId: "sc-1yhv8uz-1"
})(["width:30%;img{width:180px;}.container{height:100%;.description{margin-top:", "px;}}@media ", "{img{width:", "px;}}@media ", "{width:initial;img{width:180px;}}"], spaces.small - 2, devices.laptopM, spaces.large24X, devices.tablet);
var StyledDivider = styled_components__WEBPACK_IMPORTED_MODULE_10__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "ThreeStepSection__StyledDivider",
  componentId: "sc-1yhv8uz-2"
})(["align-items:center;display:flex;"]);
var StyledSliderNavigation = styled_components__WEBPACK_IMPORTED_MODULE_10__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "ThreeStepSection__StyledSliderNavigation",
  componentId: "sc-1yhv8uz-3"
})(["align-items:center;display:flex;justify-content:center;gap:34px;padding-right:", "px;.navButton{cursor:pointer;}.swiper-button-disabled{cursor:initial;svg{path{fill:", ";}}}"], spaces.regular, colors.gray[500]);

var ThreeStepSection = function ThreeStepSection(_ref) {
  var title = _ref.title,
      subTitle = _ref.subTitle,
      steps = _ref.steps,
      elRef = _ref.elRef;

  var _useSwiperRef = (0,_hooks__WEBPACK_IMPORTED_MODULE_8__/* .useSwiperRef */ .S)(),
      _useSwiperRef2 = (0,_builds_innova_labs_developers_trademark_trademark_frontend_v2_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(_useSwiperRef, 2),
      nextEl = _useSwiperRef2[0],
      nextElRef = _useSwiperRef2[1];

  var _useSwiperRef3 = (0,_hooks__WEBPACK_IMPORTED_MODULE_8__/* .useSwiperRef */ .S)(),
      _useSwiperRef4 = (0,_builds_innova_labs_developers_trademark_trademark_frontend_v2_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(_useSwiperRef3, 2),
      prevEl = _useSwiperRef4[0],
      prevElRef = _useSwiperRef4[1];

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsxs)(StyledThreeStepSection, {
    ref: elRef,
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("div", {
      className: "headerSection",
      children: title
    }), subTitle && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("div", {
      className: "subHeaderSection",
      children: subTitle
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("div", {
      className: "columnDesktopContainer",
      children: steps.map(function (step, idx) {
        var header = step.header,
            description = step.description,
            icon = step.icon;
        return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsxs)(react__WEBPACK_IMPORTED_MODULE_4__.Fragment, {
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(StyledStep, {
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(_components_atomic_Step__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
              top: "STEP 0".concat(idx + 1),
              bottom: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsxs)("div", {
                className: "container",
                children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("div", {
                  className: "header",
                  children: header
                }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("div", {
                  className: "description",
                  children: description
                })]
              }),
              imgSrc: icon
            })
          }), (steps === null || steps === void 0 ? void 0 : steps.length) !== idx + 1 && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(StyledDivider, {
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(_components_atomic_Icon__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
              alias: _constants_icons__WEBPACK_IMPORTED_MODULE_3__/* .ICONS_ALIASES.arrowRight */ .F.arrowRight,
              color: _constants_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.colors.blue[500] */ .r.colors.blue[500]
            })
          })]
        }, "step:".concat(idx));
      })
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("div", {
      className: "columnMobileContainer",
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsxs)(swiper_react__WEBPACK_IMPORTED_MODULE_5__/* .Swiper */ .tq, {
        spaceBetween: 16,
        slidesPerView: 'auto',
        navigation: {
          prevEl: prevEl,
          nextEl: nextEl
        },
        children: [steps.map(function (step, idx) {
          var header = step.header,
              description = step.description,
              icon = step.icon;
          return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(swiper_react__WEBPACK_IMPORTED_MODULE_5__/* .SwiperSlide */ .o5, {
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(StyledStep, {
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(_components_atomic_Step__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                top: "STEP 0".concat(idx + 1),
                bottom: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsxs)("div", {
                  className: "container",
                  children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("div", {
                    className: "header",
                    children: header
                  }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("div", {
                    className: "description",
                    children: description
                  })]
                }),
                imgSrc: icon
              })
            })
          }, "step:".concat(idx));
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsxs)(StyledSliderNavigation, {
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("div", {
            ref: prevElRef,
            className: "navButton",
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(_components_atomic_Icon__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
              alias: _constants_icons__WEBPACK_IMPORTED_MODULE_3__/* .ICONS_ALIASES.arrowLeft */ .F.arrowLeft,
              color: colors.blue[500],
              height: 20,
              width: 20
            })
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("div", {
            ref: nextElRef,
            className: "navButton",
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(_components_atomic_Icon__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
              alias: _constants_icons__WEBPACK_IMPORTED_MODULE_3__/* .ICONS_ALIASES.arrowRight */ .F.arrowRight,
              color: colors.blue[500],
              height: 20,
              width: 20
            })
          })]
        })]
      })
    })]
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (ThreeStepSection);

/***/ }),

/***/ 1450:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _constants_theme__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7579);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5444);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5893);





var colors = _constants_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.colors */ .r.colors,
    devices = _constants_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.devices */ .r.devices,
    fontSizes = _constants_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.fontSizes */ .r.fontSizes,
    spaces = _constants_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.spaces */ .r.spaces;
var StyledWhyTrademarkSection = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "WhySection__StyledWhyTrademarkSection",
  componentId: "sc-1671cdm-0"
})(["max-width:", "px;display:flex;flex-direction:column;margin-bottom:", "px;.headerSection{margin-left:", "px;margin-right:", "px;font-family:'Aeonik';font-style:normal;font-weight:500;font-size:", "px;line-height:130%;text-align:center;color:", ";flex:none;order:0;align-self:stretch;flex-grow:0;}@media ", "{padding-left:", "px;padding-right:", "px;}@media ", "{margin-top:", "px;margin-bottom:", "px;margin-left:0px;margin-right:0px;display:flex;flex-direction:column;justify-content:center;align-items:center;gap:0px;flex:none;order:1;flex-grow:0;.headerSection{font-size:", "px;line-height:150%;}}"], spaces.large24X * 10 + 80, function (_ref) {
  var isMarginBottom = _ref.isMarginBottom;
  return isMarginBottom ? spaces.large24X : 0;
}, spaces.regular, spaces.regular, fontSizes.large11X, colors.gray[800], devices.laptopM, spaces.large2X, spaces.large2X, devices.tablet, spaces.large9X, spaces.large9X, fontSizes.large2X);
var StyledWhyTrademarkContainer = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "WhySection__StyledWhyTrademarkContainer",
  componentId: "sc-1671cdm-1"
})(["display:flex;gap:", "px;margin-top:", "px;", " @media ", "{gap:0px;flex-direction:column;margin-top:", "px;", "}"], spaces.large2X - 2, spaces.large2X, function (_ref2) {
  var reverse = _ref2.reverse;
  return reverse && (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(["flex-direction:row-reverse;"]);
}, devices.tablet, spaces.smallX, function (_ref3) {
  var reverse = _ref3.reverse;
  return reverse && (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(["flex-direction:column-reverse;"]);
});
var StyledWhyLeft = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "WhySection__StyledWhyLeft",
  componentId: "sc-1671cdm-2"
})(["flex-grow:1;flex-direction:column;width:50%;text-align:right;display:flex;align-items:flex-end;justify-content:end;img{max-width:100%;max-height:100%;width:570px;}.imageHeader{text-align:left;font-family:'Aeonik';font-style:normal;font-weight:500;font-size:36px;line-height:150%;color:#344054;max-width:570px;margin-bottom:37px;}@media ", "{display:none;", "}"], devices.tablet, function (_ref4) {
  var isLeftMobileView = _ref4.isLeftMobileView;
  return isLeftMobileView && (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(["padding-left:16px;padding-right:16px;display:block;width:100%;.imageHeader{font-size:20px;text-align:center;margin-bottom:24px;}"]);
});
var StyledWhyRight = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "WhySection__StyledWhyRight",
  componentId: "sc-1671cdm-3"
})(["flex-grow:1;width:50%;display:flex;flex-direction:column;align-items:flex-start;", " ", " @media ", "{border-radius:0px;padding:0;width:100%;", "}"], function (_ref5) {
  var isFullRight = _ref5.isFullRight;
  return isFullRight && (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(["padding:", "px;gap:", "px;background-color:", ";box-shadow:0px 10px 80px rgba(0,0,0,0.05);border-radius:50px;"], spaces.large4X, spaces.large4X, colors.white);
}, function (_ref6) {
  var reverse = _ref6.reverse;
  return reverse && (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(["justify-content:center;"]);
}, devices.tablet, function (_ref7) {
  var isFullRight = _ref7.isFullRight;
  return isFullRight && (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(["gap:", "px;background-color:rgba(0,0,0,0.02);"], spaces.large2X);
});

var WhySection = function WhySection(_ref8) {
  var title = _ref8.title,
      imageTitle = _ref8.imageTitle,
      leftImage = _ref8.leftImage,
      rightPart = _ref8.rightPart,
      isFullRight = _ref8.isFullRight,
      isMarginBottom = _ref8.isMarginBottom,
      reverse = _ref8.reverse,
      isLeftMobileView = _ref8.isLeftMobileView;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)(StyledWhyTrademarkSection, {
    isMarginBottom: isMarginBottom,
    children: [title && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("div", {
      className: "headerSection",
      children: title
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)(StyledWhyTrademarkContainer, {
      reverse: reverse,
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)(StyledWhyLeft, {
        isLeftMobileView: isLeftMobileView,
        children: [imageTitle && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("div", {
          className: "imageHeader",
          children: imageTitle
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("picture", {
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("img", {
            src: leftImage,
            alt: ""
          })
        })]
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(StyledWhyRight, {
        isFullRight: isFullRight,
        reverse: reverse,
        children: rightPart
      })]
    })]
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (WhySection);

/***/ }),

/***/ 6599:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ OfficeActionResponse; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(9499);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(4730);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 3 modules
var styled_components_browser_esm = __webpack_require__(5444);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/next/config.js
var config = __webpack_require__(1752);
var config_default = /*#__PURE__*/__webpack_require__.n(config);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(1163);
// EXTERNAL MODULE: ./_constants/theme.js
var theme = __webpack_require__(7579);
// EXTERNAL MODULE: ./_constants/icons.js
var icons = __webpack_require__(934);
// EXTERNAL MODULE: ./_constants/routes.js
var routes = __webpack_require__(672);
// EXTERNAL MODULE: ./_components/atomic/layouts/form/index.js + 8 modules
var layouts_form = __webpack_require__(2890);
// EXTERNAL MODULE: ./_components/atomic/Icon/index.jsx + 49 modules
var Icon = __webpack_require__(6668);
// EXTERNAL MODULE: ./_components/atomic/Button/index.jsx
var Button = __webpack_require__(8509);
// EXTERNAL MODULE: ./_components/composed/sections/BaseBannerSection/index.jsx
var BaseBannerSection = __webpack_require__(317);
// EXTERNAL MODULE: ./_components/composed/sections/FAQSection/index.jsx
var FAQSection = __webpack_require__(3981);
// EXTERNAL MODULE: ./_components/composed/sections/BottomBannerSection/index.jsx
var BottomBannerSection = __webpack_require__(2410);
// EXTERNAL MODULE: ./_components/composed/sections/ThreeStepSection/index.jsx
var ThreeStepSection = __webpack_require__(5119);
// EXTERNAL MODULE: ./_components/composed/sections/WhySection/index.jsx
var WhySection = __webpack_require__(1450);
// EXTERNAL MODULE: ./_components/atomic/Input/index.jsx
var Input = __webpack_require__(554);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
;// CONCATENATED MODULE: ./_components/composed/sections/RightPartWhyOfficeSection/index.jsx







var colors = theme/* theme.colors */.r.colors,
    devices = theme/* theme.devices */.r.devices,
    fontSizes = theme/* theme.fontSizes */.r.fontSizes,
    spaces = theme/* theme.spaces */.r.spaces;
var StyledWhyTrademarkRight = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "RightPartWhyOfficeSection__StyledWhyTrademarkRight",
  componentId: "sc-1d6lmo6-0"
})(["padding:", "px;gap:", "px;background-color:", ";box-shadow:0px 10px 80px rgba(0,0,0,0.05);border-radius:50px;display:flex;flex-direction:column;.headerRightTrademark{font-family:'Aeonik';font-style:normal;font-weight:400;font-size:", "px;line-height:150%;text-align:justify;color:", ";}.listRightTrademark{width:100%;gap:", "px;display:flex;flex-direction:column;}@media ", "{border-radius:0px;padding:", "px;gap:", "px;.headerRightTrademark{font-size:", "px;text-align:left;}.listRightTrademark{background:", ";}}"], spaces.large4X, spaces.large2X - 2, colors.white, fontSizes.large, colors.gray[700], spaces.medium, devices.tablet, spaces.regular, spaces.regular, fontSizes.regular, colors.white);
var ButtonsPanel = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "RightPartWhyOfficeSection__ButtonsPanel",
  componentId: "sc-1d6lmo6-1"
})(["display:flex;justify-content:end;gap:30px;"]);

var RightPartWhyOfficeSection = function RightPartWhyOfficeSection() {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(StyledWhyTrademarkRight, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "headerRightTrademark",
      children: "Enter your serial number in the search bar of the USPTO trademark status page:"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "listRightTrademark",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(Input/* default */.Z, {
        borderColor: theme/* theme.colors.gray.200 */.r.colors.gray[200],
        textColor: theme/* theme.colors.gray.500 */.r.colors.gray[500],
        color: theme/* theme.colors.white */.r.colors.white,
        hoverColor: theme/* theme.colors.white */.r.colors.white,
        hoverTextColor: theme/* theme.colors.gray.500 */.r.colors.gray[500],
        placeholder: "SERIAL NUMBER"
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "headerRightTrademark",
      children: "Within the documents section, select the \"Office Action\" document to review the issues brought forth by the UPSTO concerning your application."
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(ButtonsPanel, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Button/* default */.Z, {
        textColor: theme/* theme.colors.gray.300 */.r.colors.gray[300],
        color: theme/* theme.colors.gray.400 */.r.colors.gray[400],
        children: "Documents"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Button/* default */.Z, {
        textColor: theme/* theme.colors.white */.r.colors.white,
        color: theme/* theme.colors.blue.500 */.r.colors.blue[500],
        children: "Status"
      })]
    })]
  });
};

/* harmony default export */ var sections_RightPartWhyOfficeSection = (RightPartWhyOfficeSection);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 13 modules
var es = __webpack_require__(9473);
// EXTERNAL MODULE: ./_redux/variants/selector.js
var selector = __webpack_require__(6058);
// EXTERNAL MODULE: ./_constants/processing.js
var processing = __webpack_require__(2685);
// EXTERNAL MODULE: ./_constants/products.js
var products = __webpack_require__(3193);
// EXTERNAL MODULE: ./_components/composed/sections/PriceSection/index.jsx
var PriceSection = __webpack_require__(3779);
;// CONCATENATED MODULE: ./_components/composed/pages/OfficeActionResponsePage/index.jsx


var _excluded = ["size", "rotate", "top", "bottom", "left", "right"],
    _excluded2 = ["top", "bottom", "left", "right"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }



























var _getConfig = config_default()(),
    publicRuntimeConfig = _getConfig.publicRuntimeConfig;

var OfficeActionResponsePage_colors = theme/* theme.colors */.r.colors,
    OfficeActionResponsePage_devices = theme/* theme.devices */.r.devices,
    OfficeActionResponsePage_spaces = theme/* theme.spaces */.r.spaces;
var StyledOfficeActionResponsePage = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "OfficeActionResponsePage__StyledOfficeActionResponsePage",
  componentId: "sc-1xtajih-0"
})(["position:relative;display:flex;flex-direction:column;align-items:center;@media ", "{display:block;}"], OfficeActionResponsePage_devices.tablet); // eslint-disable-next-line prettier/prettier, react/display-name

var StyledCircle = (0,styled_components_browser_esm/* default */.ZP)( /*#__PURE__*/(0,react.forwardRef)(function (_ref, ref) {
  var size = _ref.size,
      rotate = _ref.rotate,
      top = _ref.top,
      bottom = _ref.bottom,
      left = _ref.left,
      right = _ref.right,
      props = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded);

  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", _objectSpread({
    ref: ref
  }, props));
})).withConfig({
  displayName: "OfficeActionResponsePage__StyledCircle",
  componentId: "sc-1xtajih-1"
})(["position:absolute;background:", ";border-radius:50%;opacity:0.1;z-index:-1;", " ", " ", " ", " ", " ", " @media ", "{display:none;}"], "linear-gradient(180deg, ".concat(theme/* theme.colors.blue.500 */.r.colors.blue[500], " 0%, rgba(46, 144, 250, 0) 100%)"), function (_ref2) {
  var top = _ref2.top;
  return typeof top !== 'undefined' && (0,styled_components_browser_esm/* css */.iv)(["top:", ";"], typeof top === 'string' ? top : "".concat(top, "px"));
}, function (_ref3) {
  var bottom = _ref3.bottom;
  return typeof bottom !== 'undefined' && (0,styled_components_browser_esm/* css */.iv)(["bottom:", ";"], typeof bottom === 'string' ? bottom : "".concat(bottom, "px"));
}, function (_ref4) {
  var left = _ref4.left;
  return typeof left !== 'undefined' && (0,styled_components_browser_esm/* css */.iv)(["left:", ";"], typeof left === 'string' ? left : "".concat(left, "px"));
}, function (_ref5) {
  var right = _ref5.right;
  return typeof right !== 'undefined' && (0,styled_components_browser_esm/* css */.iv)(["right:", ";"], typeof right === 'string' ? right : "".concat(right, "px"));
}, function (_ref6) {
  var rotate = _ref6.rotate;
  return rotate && (0,styled_components_browser_esm/* css */.iv)(["transform:", ";"], "rotate(".concat(rotate, "deg)"));
}, function (_ref7) {
  var size = _ref7.size;
  return size && (0,styled_components_browser_esm/* css */.iv)(["width:", "px;height:", "px;"], size, size);
}, function (_ref8) {
  var theme = _ref8.theme;
  return theme.devices.tablet;
}); // eslint-disable-next-line prettier/prettier, react/display-name

var StyledImageContainer = (0,styled_components_browser_esm/* default */.ZP)( /*#__PURE__*/(0,react.forwardRef)(function (_ref9, ref) {
  var top = _ref9.top,
      bottom = _ref9.bottom,
      left = _ref9.left,
      right = _ref9.right,
      props = (0,objectWithoutProperties/* default */.Z)(_ref9, _excluded2);

  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", _objectSpread({
    ref: ref
  }, props));
})).withConfig({
  displayName: "OfficeActionResponsePage__StyledImageContainer",
  componentId: "sc-1xtajih-2"
})(["position:absolute;z-index:-1;", " ", " ", " ", " @media ", "{display:none;}"], function (_ref10) {
  var top = _ref10.top;
  return typeof top !== 'undefined' && (0,styled_components_browser_esm/* css */.iv)(["top:", ";"], typeof top === 'string' ? top : "".concat(top, "px"));
}, function (_ref11) {
  var bottom = _ref11.bottom;
  return typeof bottom !== 'undefined' && (0,styled_components_browser_esm/* css */.iv)(["bottom:", ";"], typeof bottom === 'string' ? bottom : "".concat(bottom, "px"));
}, function (_ref12) {
  var left = _ref12.left;
  return typeof left !== 'undefined' && (0,styled_components_browser_esm/* css */.iv)(["left:", ";"], typeof left === 'string' ? left : "".concat(left, "px"));
}, function (_ref13) {
  var right = _ref13.right;
  return typeof right !== 'undefined' && (0,styled_components_browser_esm/* css */.iv)(["right:", ";"], typeof right === 'string' ? right : "".concat(right, "px"));
}, function (_ref14) {
  var theme = _ref14.theme;
  return theme.devices.tablet;
});

var OfficeActionResponsePage = function OfficeActionResponsePage() {
  var router = (0,next_router.useRouter)();
  var priceMapByStandardProcessing = (0,es/* useSelector */.v9)((0,selector/* selectPriceMapByProcessingCode */.Ej)(processing/* PROCESSING_OPTIONS_KEYS.standard */.I.standard));
  var productPrice = priceMapByStandardProcessing[products/* PRODUCT_CODES.tmOfficeActionResponse */.P.tmOfficeActionResponse];
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(StyledOfficeActionResponsePage, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(BaseBannerSection/* default */.Z, {
      hideImageMobile: true,
      imgSrc: "".concat(publicRuntimeConfig.basePath, "/images/office-action-response.svg"),
      title: "Office Action Response",
      text: "Don't give up on your trademark or miss the response deadline! Responses to the USPTO must be filed within 6 months of the mailing date printed on the Office Action document.",
      buttons: [{
        onClick: function onClick() {
          return router.push(routes/* ROUTES.officeActionResponseFiling */.Z.officeActionResponseFiling);
        },
        text: 'File Office Action Now',
        color: theme/* theme.colors.blue.500 */.r.colors.blue[500],
        suffix: /*#__PURE__*/(0,jsx_runtime.jsx)(Icon/* default */.Z, {
          alias: icons/* ICONS_ALIASES.arrowRight */.F.arrowRight,
          color: OfficeActionResponsePage_colors.white
        })
      }]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(ThreeStepSection/* default */.Z, {
      title: "3 Step Process",
      steps: [{
        header: 'Complete Our Online Questionnaire',
        description: 'All information gathered is confidential and secured.',
        icon: "".concat(publicRuntimeConfig.basePath, "/images/my-answers-bubble.svg")
      }, {
        header: 'Our Specialists Prepare Your Office Action Response',
        description: 'Your Office Action issues are evaluated to verify eligibility for our handling. Once verified, the response is prepared and reviewed for submission.',
        icon: "".concat(publicRuntimeConfig.basePath, "/images/app-development-bubble.svg")
      }, {
        header: 'The Office Action Response is Filed with the UPSTO',
        description: 'The response is reviewed with you prior to submission. Once approved and submitted, we will update you will all status changes.',
        icon: "".concat(publicRuntimeConfig.basePath, "/images/app-filed.svg")
      }]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(layouts_form/* Divider */.iz, {
      desktop: true,
      size: OfficeActionResponsePage_spaces.large24X
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(WhySection/* default */.Z, {
      title: "Determining Issues to Be Addressed in Response",
      leftImage: "".concat(publicRuntimeConfig.basePath, "/images/office-action-response-why.png"),
      rightPart: /*#__PURE__*/(0,jsx_runtime.jsx)(sections_RightPartWhyOfficeSection, {})
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(PriceSection/* default */.Z, {
      title: "Office Action Response",
      subtitle: "WE\u2019LL HELP YOU OVERCOME YOUR OFFICE ACTION.",
      price: productPrice,
      priceText: "per filing",
      bullets: ['Assessment of response eligibility', 'Professionally formatted report and review done by specialists', 'High approval rate from our responses'],
      buttons: [{
        text: 'File Office Action Now',
        color: OfficeActionResponsePage_colors.white,
        textColor: OfficeActionResponsePage_colors.blue[500],
        suffix: /*#__PURE__*/(0,jsx_runtime.jsx)(Icon/* default */.Z, {
          alias: icons/* ICONS_ALIASES.arrowRight */.F.arrowRight,
          color: OfficeActionResponsePage_colors.blue[500]
        }),
        onClick: function onClick() {
          return router.push(routes/* ROUTES.officeActionResponseFiling */.Z.officeActionResponseFiling);
        }
      }]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(FAQSection/* default */.Z, {}), /*#__PURE__*/(0,jsx_runtime.jsx)(BottomBannerSection/* default */.Z, {
      header: /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: "Don't wait, Protect Your Brand now"
      }),
      footer: /*#__PURE__*/(0,jsx_runtime.jsx)(Button/* default */.Z, {
        suffix: /*#__PURE__*/(0,jsx_runtime.jsx)(Icon/* default */.Z, {
          alias: icons/* ICONS_ALIASES.arrowRight */.F.arrowRight,
          color: theme/* theme.colors.blue.500 */.r.colors.blue[500]
        }),
        color: theme/* theme.colors.white */.r.colors.white,
        onClick: function onClick() {
          return router.push(routes/* ROUTES.trademarkRegistrationFiling */.Z.trademarkRegistrationFiling);
        },
        textColor: theme/* theme.colors.blue.500 */.r.colors.blue[500],
        hoverColor: theme/* theme.colors.white */.r.colors.white,
        hoverTextColor: theme/* theme.colors.blue.500 */.r.colors.blue[500],
        children: "File Office Action Now"
      }),
      imgSrc: "".concat(publicRuntimeConfig.basePath, "/images/trademark-registration-bottom.svg"),
      imgTopDesktopPosition: "-130px",
      moreSpace: true,
      disclaimer: true
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(StyledCircle, {
      size: 686,
      rotate: 90,
      right: -135,
      top: 'calc(28% + 10px)'
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(StyledCircle, {
      size: 743,
      rotate: 180,
      left: -197,
      top: 'calc(32% + 30px)'
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(StyledImageContainer, {
      left: 65,
      top: '50%',
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("picture", {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("source", {
          srcSet: "".concat(publicRuntimeConfig.basePath, "/images/dots.svg"),
          type: "image/svg"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
          src: "".concat(publicRuntimeConfig.basePath, "/images/dots.svg"),
          alt: ""
        })]
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(StyledCircle, {
      size: 820,
      rotate: -180,
      right: -202,
      top: 'calc(73% + 10px)'
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(StyledImageContainer, {
      right: 65,
      top: 'calc(80% + 20px)',
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("picture", {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("source", {
          srcSet: "".concat(publicRuntimeConfig.basePath, "/images/dots.svg"),
          type: "image/svg"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
          src: "".concat(publicRuntimeConfig.basePath, "/images/dots.svg"),
          alt: ""
        })]
      })
    })]
  });
};

/* harmony default export */ var pages_OfficeActionResponsePage = (OfficeActionResponsePage);
// EXTERNAL MODULE: ./node_modules/next-seo/lib/next-seo.module.js
var next_seo_module = __webpack_require__(2962);
;// CONCATENATED MODULE: ./pages/office-action-response.js





function OfficeActionResponse() {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(next_seo_module/* NextSeo */.PB, {
      title: "Office Action Response"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(pages_OfficeActionResponsePage, {})]
  });
}

/***/ }),

/***/ 6858:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/office-action-response",
      function () {
        return __webpack_require__(6599);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 8697:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "P1": function() { return /* binding */ createSelector; }
});

// UNUSED EXPORTS: createSelectorCreator, createStructuredSelector, defaultEqualityCheck, defaultMemoize

;// CONCATENATED MODULE: ./node_modules/reselect/es/defaultMemoize.js
// Cache implementation based on Erik Rasmussen's `lru-memoize`:
// https://github.com/erikras/lru-memoize
var NOT_FOUND = 'NOT_FOUND';

function createSingletonCache(equals) {
  var entry;
  return {
    get: function get(key) {
      if (entry && equals(entry.key, key)) {
        return entry.value;
      }

      return NOT_FOUND;
    },
    put: function put(key, value) {
      entry = {
        key: key,
        value: value
      };
    },
    getEntries: function getEntries() {
      return entry ? [entry] : [];
    },
    clear: function clear() {
      entry = undefined;
    }
  };
}

function createLruCache(maxSize, equals) {
  var entries = [];

  function get(key) {
    var cacheIndex = entries.findIndex(function (entry) {
      return equals(key, entry.key);
    }); // We found a cached entry

    if (cacheIndex > -1) {
      var entry = entries[cacheIndex]; // Cached entry not at top of cache, move it to the top

      if (cacheIndex > 0) {
        entries.splice(cacheIndex, 1);
        entries.unshift(entry);
      }

      return entry.value;
    } // No entry found in cache, return sentinel


    return NOT_FOUND;
  }

  function put(key, value) {
    if (get(key) === NOT_FOUND) {
      // TODO Is unshift slow?
      entries.unshift({
        key: key,
        value: value
      });

      if (entries.length > maxSize) {
        entries.pop();
      }
    }
  }

  function getEntries() {
    return entries;
  }

  function clear() {
    entries = [];
  }

  return {
    get: get,
    put: put,
    getEntries: getEntries,
    clear: clear
  };
}

var defaultEqualityCheck = function defaultEqualityCheck(a, b) {
  return a === b;
};
function createCacheKeyComparator(equalityCheck) {
  return function areArgumentsShallowlyEqual(prev, next) {
    if (prev === null || next === null || prev.length !== next.length) {
      return false;
    } // Do this in a for loop (and not a `forEach` or an `every`) so we can determine equality as fast as possible.


    var length = prev.length;

    for (var i = 0; i < length; i++) {
      if (!equalityCheck(prev[i], next[i])) {
        return false;
      }
    }

    return true;
  };
}
// defaultMemoize now supports a configurable cache size with LRU behavior,
// and optional comparison of the result value with existing values
function defaultMemoize(func, equalityCheckOrOptions) {
  var providedOptions = typeof equalityCheckOrOptions === 'object' ? equalityCheckOrOptions : {
    equalityCheck: equalityCheckOrOptions
  };
  var _providedOptions$equa = providedOptions.equalityCheck,
      equalityCheck = _providedOptions$equa === void 0 ? defaultEqualityCheck : _providedOptions$equa,
      _providedOptions$maxS = providedOptions.maxSize,
      maxSize = _providedOptions$maxS === void 0 ? 1 : _providedOptions$maxS,
      resultEqualityCheck = providedOptions.resultEqualityCheck;
  var comparator = createCacheKeyComparator(equalityCheck);
  var cache = maxSize === 1 ? createSingletonCache(comparator) : createLruCache(maxSize, comparator); // we reference arguments instead of spreading them for performance reasons

  function memoized() {
    var value = cache.get(arguments);

    if (value === NOT_FOUND) {
      // @ts-ignore
      value = func.apply(null, arguments);

      if (resultEqualityCheck) {
        var entries = cache.getEntries();
        var matchingEntry = entries.find(function (entry) {
          return resultEqualityCheck(entry.value, value);
        });

        if (matchingEntry) {
          value = matchingEntry.value;
        }
      }

      cache.put(arguments, value);
    }

    return value;
  }

  memoized.clearCache = function () {
    return cache.clear();
  };

  return memoized;
}
;// CONCATENATED MODULE: ./node_modules/reselect/es/index.js



function getDependencies(funcs) {
  var dependencies = Array.isArray(funcs[0]) ? funcs[0] : funcs;

  if (!dependencies.every(function (dep) {
    return typeof dep === 'function';
  })) {
    var dependencyTypes = dependencies.map(function (dep) {
      return typeof dep === 'function' ? "function " + (dep.name || 'unnamed') + "()" : typeof dep;
    }).join(', ');
    throw new Error("createSelector expects all input-selectors to be functions, but received the following types: [" + dependencyTypes + "]");
  }

  return dependencies;
}

function createSelectorCreator(memoize) {
  for (var _len = arguments.length, memoizeOptionsFromArgs = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    memoizeOptionsFromArgs[_key - 1] = arguments[_key];
  }

  var createSelector = function createSelector() {
    for (var _len2 = arguments.length, funcs = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      funcs[_key2] = arguments[_key2];
    }

    var _recomputations = 0;

    var _lastResult; // Due to the intricacies of rest params, we can't do an optional arg after `...funcs`.
    // So, start by declaring the default value here.
    // (And yes, the words 'memoize' and 'options' appear too many times in this next sequence.)


    var directlyPassedOptions = {
      memoizeOptions: undefined
    }; // Normally, the result func or "output selector" is the last arg

    var resultFunc = funcs.pop(); // If the result func is actually an _object_, assume it's our options object

    if (typeof resultFunc === 'object') {
      directlyPassedOptions = resultFunc; // and pop the real result func off

      resultFunc = funcs.pop();
    }

    if (typeof resultFunc !== 'function') {
      throw new Error("createSelector expects an output function after the inputs, but received: [" + typeof resultFunc + "]");
    } // Determine which set of options we're using. Prefer options passed directly,
    // but fall back to options given to createSelectorCreator.


    var _directlyPassedOption = directlyPassedOptions,
        _directlyPassedOption2 = _directlyPassedOption.memoizeOptions,
        memoizeOptions = _directlyPassedOption2 === void 0 ? memoizeOptionsFromArgs : _directlyPassedOption2; // Simplifying assumption: it's unlikely that the first options arg of the provided memoizer
    // is an array. In most libs I've looked at, it's an equality function or options object.
    // Based on that, if `memoizeOptions` _is_ an array, we assume it's a full
    // user-provided array of options. Otherwise, it must be just the _first_ arg, and so
    // we wrap it in an array so we can apply it.

    var finalMemoizeOptions = Array.isArray(memoizeOptions) ? memoizeOptions : [memoizeOptions];
    var dependencies = getDependencies(funcs);
    var memoizedResultFunc = memoize.apply(void 0, [function recomputationWrapper() {
      _recomputations++; // apply arguments instead of spreading for performance.

      return resultFunc.apply(null, arguments);
    }].concat(finalMemoizeOptions)); // If a selector is called with the exact same arguments we don't need to traverse our dependencies again.

    var selector = memoize(function dependenciesChecker() {
      var params = [];
      var length = dependencies.length;

      for (var i = 0; i < length; i++) {
        // apply arguments instead of spreading and mutate a local list of params for performance.
        // @ts-ignore
        params.push(dependencies[i].apply(null, arguments));
      } // apply arguments instead of spreading for performance.


      _lastResult = memoizedResultFunc.apply(null, params);
      return _lastResult;
    });
    Object.assign(selector, {
      resultFunc: resultFunc,
      memoizedResultFunc: memoizedResultFunc,
      dependencies: dependencies,
      lastResult: function lastResult() {
        return _lastResult;
      },
      recomputations: function recomputations() {
        return _recomputations;
      },
      resetRecomputations: function resetRecomputations() {
        return _recomputations = 0;
      }
    });
    return selector;
  }; // @ts-ignore


  return createSelector;
}
var createSelector = /* #__PURE__ */createSelectorCreator(defaultMemoize);
// Manual definition of state and output arguments
var createStructuredSelector = function createStructuredSelector(selectors, selectorCreator) {
  if (selectorCreator === void 0) {
    selectorCreator = createSelector;
  }

  if (typeof selectors !== 'object') {
    throw new Error('createStructuredSelector expects first argument to be an object ' + ("where each property is a selector, instead received a " + typeof selectors));
  }

  var objectKeys = Object.keys(selectors);
  var resultSelector = selectorCreator( // @ts-ignore
  objectKeys.map(function (key) {
    return selectors[key];
  }), function () {
    for (var _len3 = arguments.length, values = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      values[_key3] = arguments[_key3];
    }

    return values.reduce(function (composition, value, index) {
      composition[objectKeys[index]] = value;
      return composition;
    }, {});
  });
  return resultSelector;
};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9460,9707,3346,2890,1336,2336,3981,9774,2888,179], function() { return __webpack_exec__(6858); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);